
import { useState, useEffect } from 'react';
import PointsService from '../Points/PointsService';
import { toast } from 'react-toastify';
import { toastOptions } from '../lib/toastOptions';

export const usePointsSystem = (userId) => {
  const [pointsData, setPointsData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Load user points
  const loadUserPoints = async () => {
    if (!userId) return;
    
    setLoading(true);
    setError(null);
    try {
      const data = await PointsService.getUserPoints(userId);
      setPointsData(data);
    } catch (err) {
      setError(err);
      console.error('Failed to load points:', err);
    } finally {
      setLoading(false);
    }
  };

  // Award points for an activity (now accepts fields parameter)
  const awardPoints = async (activityType, fields = {}) => {
    if (!userId) return;
    
    setLoading(true);
    setError(null);
    try {
      await PointsService.awardPoints(userId, activityType, fields);
      await loadUserPoints(); // Refresh points data
      return true;
    } catch (err) {
      setError(err);
      return false;
    } finally {
      setLoading(false);
    }
  };

  // Add deductPoints function to the hook
  const deductPoints = async (activityType, fields = {}) => {
    console.log('userId in deduct points',userId);
    
    if (!userId) return;
    
    setLoading(true);
    setError(null);
    try {
      await PointsService.deductPoints(userId, activityType, fields);
      console.log('Points deducted');
      
      await loadUserPoints(); // Refresh points data
      return true;
    } catch (err) {
      setError(err);
      return false;
    } finally {
      setLoading(false);
    }
  };

  // Initialize on mount and when userId changes
  useEffect(() => {
    loadUserPoints();
  }, [userId]);

  return {
    pointsData,
    loading,
    error,
    awardPoints,
    deductPoints, // Make deductPoints available
    refreshPoints: loadUserPoints
  };
};